<template>
    <breadCrumbs title="Basic tables" main="Bootstrap Tables" title1="Basic tables" />
    <div class="container-fluid basic_table">
        <div class="row">
            <basicTable />
            <inverseTable />
            <hoverableRows />
            <backgroundUtilities />
            <captionTable />
            <tableHead />
            <stripedRow />
            <responsiveTables />
            <sizingTable />
            <breckpointSpecific />
        </div>
    </div>
</template>
<script>
import basicTable from "./basicTable.vue"
import inverseTable from "./inverseTable.vue"
import hoverableRows from "./hoverableRows.vue"
import backgroundUtilities from "./backgroundUtilities.vue"
import tableHead from "./tableHead.vue"
import stripedRow from "./stripedRow.vue"
import captionTable from "./captionTable.vue"
import responsiveTables from "./responsiveTables.vue"
import breckpointSpecific from "./breckpointSpecific.vue"
import sizingTable from "./sizingTable.vue"
export default {
    components: {
        basicTable,
        inverseTable,
        hoverableRows,
        backgroundUtilities,
        tableHead,
        stripedRow,
        captionTable,
        responsiveTables,
        breckpointSpecific,
        sizingTable
    }
}
</script>